import { Component, Injector, Input, OnInit } from '@angular/core';
import { OrganizationLocationService } from 'app/core/http/services/organization-location.service';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { PractitionerroleService } from 'app/core/http/services/practitionerrole.service';
import { Practitioner } from 'app/core/interfaces/practitioner';
import { Location } from 'app/core/interfaces/location';
import { BaseComponent } from '../base.component';
import { PractitionerInfoDialogComponent } from '../practitioner-info-dialog/practitioner-info-dialog.component';
import { Practitionerrole } from 'app/core/interfaces/practitionerrole';
import { Healthcareservice } from 'app/core/interfaces/healthcareservice';
import { UtilsService } from '../../utils.service';
import { friendlyProcedureName } from '../../models/schedule-search.models';
import { summarizeSchedulePayment } from '../../models/schedule-payment-summary';

@Component({
  selector: 'schedule-specialist-info',
  templateUrl: './schedule-specialist-info.component.html',
  styleUrls: ['./schedule-specialist-info.component.css']
})
export class ScheduleSpecialistInfoComponent extends BaseComponent {

  @Input() practitioner ?: Practitioner;
  @Input() index ?: number = 0;
  @Input() location ?: any
  @Input() practitionerRole ?: any
  @Input() healthcareservice ?: Healthcareservice

  constructor(
    private locationService: OrganizationLocationService,
    private practitionerService: PractitionerService,
    private practitionerRoleService: PractitionerroleService,
    private utilsService: UtilsService,
    private inject: Injector
  ) { 
    super(inject)
  }

  ngOnInit(): void {
  }

  getPractitionerPhoto() {
    const url = this.practitioner  && this.practitioner.photo ? this.practitioner.photo : this.defaultPractitionerPhoto;
    return url;
  }

  getLocation(): string {
    const address = this.location?.address ?? this.location;
    const addressLine = [address?.street, address?.number].filter(Boolean).join(', ');
    const cityLine = [address?.city, address?.state].filter(Boolean).join('-');
    return [addressLine, cityLine].filter(Boolean).join(', ') || 'Localização não informada';
  }

  getProcedureDisplayName(): string {
    return friendlyProcedureName(this.healthcareservice?.name);
  }

  getPaymentSummary(): string | null {
    return summarizeSchedulePayment(this.healthcareservice ? [this.healthcareservice] : []).compactLabel;
  }

  openGoogleMapsLocation() {
    const mapUrl = this.location?.mapUrl;
    if (mapUrl) window.open(mapUrl, '_blank', 'noopener,noreferrer');
  }



  getPractitionerRole(): string | null {
    const practitionerRole = this.practitionerRole;   

    if (!practitionerRole || !Array.isArray(practitionerRole.specialty)) return null;
    return practitionerRole.specialty.map((s: any) => `${s.value} - CRM: ${s.crm}`).join(', ');
  }

  openPractitionerInfos() {
    
    const data = {
      param: {
        specialist: this.practitioner,
        practitionerRole: this.practitionerRole,
      },
    };

    this.dialog.openComponentDialog(PractitionerInfoDialogComponent, data);
  }

  public toggleHorarios(index?: number) {
    this.utilsService.toggleHorarios(index);    
  }

}
